module.exports = __webpack_public_path__ + "img/icon-mention.6c6cebd.svg";